import { useQuery } from '@tanstack/react-query';
import DataTable from '@/components/data-table/DataTable';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';
import { API } from '@/services/api.service';
import { QUERY_KEY } from '@/shared/constants';
import HRDocumentsColumns from './HRDocumentsColumns';

export default function EmployeeHRDocumentsList({
  employeeId,
  // The profile page fits the list (pager included) into its own box.
  className = 'h-[calc(100svh_-_270px)]',
  wrapperClassName = '',
}) {
  const { queryParams, setQueryParams } = useQueryParamsContext();

  const { data, status } = useQuery({
    queryKey: [QUERY_KEY.employeeHrDocuments, queryParams, employeeId],
    queryFn: async () => {
      const params = {
        ...queryParams,
        employee: employeeId,
      };

      return await API.documents.retrieveAllDocuments({
        params,
        from: 'employee-hr-documents',
      });
    },
    enabled: !!employeeId,
  });

  const hrDocumentsData = data?.items || [];
  const total = data?.count || 0;

  return (
    <>
      <DataTable
        total={total}
        data={hrDocumentsData}
        title={null}
        columns={HRDocumentsColumns()}
        offset={queryParams.offset}
        limit={queryParams.limit}
        onChangePagination={setQueryParams}
        className={className}
        rowKey="requestId"
        status={status}
        metadata={{
          columnLength: 4,
          contentWrapperClass: `border-0 ${wrapperClassName}`,
        }}
      />
    </>
  );
}
